import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import { products } from "../dataList";

const Alarmas = () => {
  const getData = () => {
    setListaProductos(products.filter((x) => x.tags.includes("alarma")));
  };

  const [listaProductos, setListaProductos] = useState([]);
  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="main">
      <section className="servicios relative mt-5">
        <div className="l-pad-2">
          <h2>Alarmas contra intrusión e incendios</h2>
        </div>

        <div className="servicios__container l-mw-90 l-grid repeat4">
          {listaProductos.map((item, index) => {
            return <ProductCard props={item} key={index} />;
          })}
        </div>
      </section>
    </div>
  );
};

export default Alarmas;
